import React from 'react';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import TVProductLobbyPageData from 'Models/Content/TVProductLobbyPageData';

export default class TVProductLobbyPage extends Page<TVProductLobbyPageData> {
  render() {
   
    const {
      data: {mainContentArea},
      context,
      } = this.props;

      if (typeof window.scrollTo === 'function') {
          window.scrollTo(0, 0);
      }
    return (
      <div className='TVProductLobbyPage'>
        <ContentArea data={mainContentArea} context={context} noWrap />
      </div>
    );
  }
}
